/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHexagonExclamationEmpty: {
  name: 'hexagon-exclamation-empty';
  data: string;
} = {
  name: 'hexagon-exclamation-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 2.586A2 2 0 0 1 8.414 2h7.172A2 2 0 0 1 17 2.586L21.414 7A2 2 0 0 1 22 8.414v7.172A2 2 0 0 1 21.414 17L17 21.414a2 2 0 0 1-1.414.586H8.414A2 2 0 0 1 7 21.414L2.586 17A2 2 0 0 1 2 15.586V8.414A2 2 0 0 1 2.586 7L7 2.586ZM15.586 4H8.414L4 8.414v7.172L8.414 20h7.172L20 15.586V8.414L15.586 4ZM12 7a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
